export class AbbreviationLineGenerator {
  
  private static readonly STANDARD_ABBREVIATIONS = {
    'CT*': 'CARATS',
    'COL*': 'COLOR',
    'CL*': 'CLARITY', 
    'NAT*': 'NATURAL',
    'LAB*': 'LAB GROWN'
  };
  
  /**
   * Generate abbreviation lines based on usage
   */
  static generateAbbreviationLines(usedAbbreviations: Set<string>): string[] {
    const abbreviationLines: string[] = Array(13).fill('');
    
    let index = 0;
    for (const abbrev of usedAbbreviations) {
      if (index < 13 && this.STANDARD_ABBREVIATIONS[abbrev as keyof typeof this.STANDARD_ABBREVIATIONS]) {
        const definition = `${abbrev} = ${this.STANDARD_ABBREVIATIONS[abbrev as keyof typeof this.STANDARD_ABBREVIATIONS]}`;
        
        // Ensure 31 character limit
        abbreviationLines[index] = definition.substring(0, 31);
        index++;
      }
    }
    
    return abbreviationLines;
  }
  
  /**
   * Validate no duplicate abbreviations
   */
  static validateNoDuplicates(abbreviationLines: string[]): boolean {
    const abbreviations = abbreviationLines
      .filter(line => line.trim() !== '')
      .map(line => line.split('=')[0].trim());
    
    const uniqueAbbreviations = new Set(abbreviations);
    return abbreviations.length === uniqueAbbreviations.size;
  }
  
  /**
   * Get all standard abbreviation definitions
   */
  static getStandardAbbreviations(): Record<string, string> {
    return { ...this.STANDARD_ABBREVIATIONS };
  }
  
  /**
   * Check if an abbreviation is a standard one
   */
  static isStandardAbbreviation(abbrev: string): boolean {
    return abbrev in this.STANDARD_ABBREVIATIONS;
  }
} 